export default __webpack_public_path__ + "static/media/Forest-Layer-4.1d9d0f3d.png";